import { render, staticRenderFns } from "./SmartCatalog.vue?vue&type=template&id=3011a3d0&scoped=true&"
import script from "./SmartCatalog.vue?vue&type=script&lang=js&"
export * from "./SmartCatalog.vue?vue&type=script&lang=js&"
import style0 from "./SmartCatalog.vue?vue&type=style&index=0&id=3011a3d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3011a3d0",
  null
  
)

export default component.exports